import { Injectable } from '@angular/core';
import { AuthEntity, LoginModel } from '@admin/core/models';
import { BaseApi } from './_base-api';

@Injectable({
  providedIn: 'root',
})
export class AuthApiService extends BaseApi<any> {
  constructor() {
    super('');
  }

  login(model: LoginModel) {
    return http$.post<AuthEntity>('/Auth/admin/Login', model);
  }

  downloadImage(url: string) {
    return http$.get(url, {
      responseType: 'blob'
    });
  }
}
